import styled from "styled-components";
import { colors } from "assets";

export default c => styled(c)`
  .integration-status {
    display: inline-flex;
  }

  .subheading-style {
    display: block;
    text-align: justify;
  }

  .done-icon {
    font-size: 1.4em;
    color: ${colors.secondary.dark};
  }

  .close-icon {
    font-size: 1.4em;
    color: red;
  }

  .icon-span {
    padding-left: 6px;
    font-weight: bold;
    font-size: 1.1em;
  }

  .tooltip {
    padding: 10px 0px 0px 6px;
  }

  .tooltip-icon {
    color: ${colors.primary.dark};
  }

  .integration_submit {
    padding-bottom: 500px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/my-finance/style.js